(() => {
  angular.module('app').controller('finance.views.curlecPayout', FinanceCurlecPayoutController);

  FinanceCurlecPayoutController.$inject = [
    'abp.services.finance.commonLookup',
    'abp.services.app.exportToExcel',
  ];

  function FinanceCurlecPayoutController(commonLookupSvc, exportToExcelSvc) {
    const vm = this;

    vm.loading = 0;
    vm.enqueuing = 0;
    vm.pageState = null;
    vm.dataExportRecordName = 'CurlecPayoutListing';
    vm.generateButtonType = App.localize('ExportToExcel');

    init();

    function init() {
      getSettings();
    }

    function getSettings() {
      vm.loading += 1;
      commonLookupSvc
        .getCommonSettings()
        .success((data) => {
          if (data.curlecPayoutIntegration) {
            vm.pageState = 0;
          } else {
            abp.message.warn('Cannot load because this feature is not enabled.');
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function calculateTotalAmount(items) {
      return items.reduce((total, record) => total + record.outstandingAmount, 0);
    }
  }
})();
